import { useContext, useEffect, useMemo, useState } from 'react'
import { Subscription } from 'rxjs'
import { indexBy } from '@cicero/data/utils'
import { useModel } from './useModel'
import { AttributeDoc, AttributeType } from '../AttributeSchema'
import { AttributeOptionSchema } from '../AttributeOptionSchema'
import { PageSchema } from '../PageSchema'
import { IPageFilter, PageFilterOptionsContext } from '../filters'
import { mapFiltersToPageQuery } from './mapFiltersToPageQuery'

/**
 * Loads an array of possible values for a given attribute, e.g options, or matching pages
 * @param attr 
 * @param filters 
 */
export const useAttributeOptions = (attr: AttributeDoc|null, filters?: IPageFilter[]) => {
  const AttributeOptions = useModel(AttributeOptionSchema)
  const Pages = useModel(PageSchema)
  const availableFilterOptions = useContext(PageFilterOptionsContext)
  const availableFilterOptionsLookup = useMemo(() => indexBy(availableFilterOptions, 'id', true), [availableFilterOptions])
  const [options, setOptions] = useState<{ id: string, value: any }[]>([])

  useEffect(() => {
    let sub: Subscription
    if (!attr) { return }
    switch (attr.type) {
      case AttributeType.option:
        sub = AttributeOptions.QUERY$({ selector: { attribute_id: attr.id } })
          // .pipe(debounceTime(50))
          .subscribe((opts) => {
            setOptions(opts)
          })
        break

      case AttributeType.linkedpage:
        const { pageQuery } = mapFiltersToPageQuery(filters || [], availableFilterOptionsLookup)
        sub = Pages.QUERY$(pageQuery || { selector: {} })
          .subscribe(pages => {
            setOptions(pages.map(page => ({ id: page.id, value: page })))
          })
        break
    }
    return () => {
      if (sub) { sub.unsubscribe() }
    }
  }, [attr])

  return options
}
